export default function setNotification(detail) {
    document.dispatchEvent(new CustomEvent('notification', { detail }));
}
